import { Component } from '@angular/core';
import { NavController, ViewController } from 'ionic-angular';

@Component({
  template: `
    <ion-list>
      <ion-item>    
        <button ion-button clear icon-start (click)="closePopover('add-continuing-ed')">
          <ion-icon name="add"></ion-icon> Add Continuing Education
        </button>
      </ion-item>
      <ion-item>
        <button ion-button color="danger" clear icon-start (click)="closePopover('delete')">
          <ion-icon name="trash"></ion-icon> Delete
        </button>
      </ion-item>
    </ion-list>  
  `
})
export class ListActionsPopoverPage {

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController
  )
  {
    
  }

  closePopover( selectedItem )
  {
    this.viewCtrl.dismiss( selectedItem );
  }

}



// WEBPACK FOOTER //
// ./src/components/popovers/list-actions.popover.ts